import opentype from 'opentype.js';

let cachedFont: opentype.Font | null = null;

export async function loadDefaultFont(): Promise<void> {
  const response = await fetch('/fonts/LiberationSans-Regular.ttf');
  const buffer = await response.arrayBuffer();
  cachedFont = opentype.parse(buffer);
}

export function getFont(): opentype.Font {
  if (!cachedFont) throw new Error('Font not loaded yet');
  return cachedFont;
}
